// @flow strict

// $FlowFixMe[nonstrict-import]
import type {Dispatch, ThunkAction} from 'src/reducers';
import type {
  ActiveJobsFilterColumnsData,
  FilterColumns,
} from 'src/types/discover';

// $FlowFixMe[nonstrict-import]
import {thunkify as flow} from 'src/utils/thunks';

// $FlowFixMe[nonstrict-import]
import * as reduxApi from 'src/utils/redux-api-bff.ts';

// $FlowFixMe[untyped-import]
import {fetching, key} from 'src/utils/redux';


export const RECEIVE_ACTIVE_JOBS_TABLE_COLUMNS =
  'discover-active-jobs/receive-active-jobs-table-columns';

type ReceiveActiveJobsTableColumnAction = {
  type: typeof RECEIVE_ACTIVE_JOBS_TABLE_COLUMNS;
  payload: ActiveJobsFilterColumnsData;
};

export type DiscoverActiveJobsActions = ReceiveActiveJobsTableColumnAction;

const receiveActiveJobsTableColumnSelection = (
  payload: ActiveJobsFilterColumnsData,
): ReceiveActiveJobsTableColumnAction => ({
  type: RECEIVE_ACTIVE_JOBS_TABLE_COLUMNS,
  payload,
});

export const getActiveJobsTableFilterColumn: () => ThunkAction<unknown> = flow(
  key(() => 'getActiveJobsTableFilterColumn'),
  fetching(),
)(() => async (dispatch: Dispatch) => {
  try {
    const payload: ActiveJobsFilterColumnsData = await dispatch(
      reduxApi.get('discover/jobs/configuration'),
    );
    dispatch(receiveActiveJobsTableColumnSelection(payload));
  } catch (error) {
    console.error('Error fetching all responses table column filter:', error);
  }
});

export const saveActiveJobsFilterColumns: (
  columnData: FilterColumns,
) => ThunkAction<unknown> = flow()(
  (columnData) => async (dispatch: Dispatch) =>
    dispatch(
      reduxApi.post('discover/jobs/configuration', {columns: columnData}, {}),
    ),
);
